import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSiteContent } from "../lib/siteContent";

// Persistent, subtle entry point to the Baby Name Explorer, shown on every page of the
// Baby & Early Years Hub (including inside journeys). Journey pages link to that
// journey's own names workspace; the hub itself links to the public explorer.
export function BabyNameExplorerLink() {
  const { pathname } = useLocation();
  const sc = useSiteContent();
  if (!pathname.startsWith("/app/baby")) return null;
  const m = pathname.match(/^\/app\/baby\/([^/]+)/);
  const journeyId = m && m[1] !== "new" ? m[1] : null;
  const to = journeyId ? `/app/baby/${journeyId}/names` : "/names";
  if (journeyId && pathname === to) return null;
  return (
    <Link to={to} data-testid="baby-name-explorer-link" aria-label="Open the Baby Name Explorer"
      className="fixed bottom-[calc(4.75rem+env(safe-area-inset-bottom))] left-4 z-[70] flex items-center gap-1.5 rounded-full border border-[#0F766E]/25 bg-white/90 px-3.5 py-2 text-xs font-semibold text-[#0F766E] shadow-md backdrop-blur transition-transform hover:-translate-y-0.5 active:scale-95 md:bottom-5 md:left-[17.5rem]">
      <img src={sc.brand_bne_logo || "/brand/bne-logo.webp"} alt="" className="h-4 w-4 object-contain" /> Name Explorer
    </Link>
  );
}
